import React from 'react';
import moment from 'moment';
import { withLocalize} from 'react-localize-redux';
import BbInput from "../../styling/bbInput";
import BbDatePicker from '../../common/datePicker';
import { isNullOrUndefined } from "util";
import { connect as connectFormik } from 'formik';

class DateRange extends React.Component {
    render() {
        return (
            <div className="search-filter-content">
                {this.renderCreationDate(0, "From")}
                {this.renderCreationDate(1, "To")}
            </div>
        );
    }

    onDateChange = (idx, day) => {
        moment.locale('cs');
        if (moment(day, "l", true).isValid())
            this.props.formik.setFieldValue(this.props.filter.Key + (idx === 0 ? "From" : "To"), [moment(day, "l").format("YYYY-MM-DD")]);
        else if(moment(day, "L", true).isValid()) 
            this.props.formik.setFieldValue(this.props.filter.Key + (idx === 0 ? "From" : "To"), [moment(day, "L").format("YYYY-MM-DD")]);
        else if(day === "")
            this.props.formik.setFieldValue(this.props.filter.Key + (idx === 0 ? "From" : "To"), "");
    }

    renderCreationDate = (idx, suffix) => {
        let val = !isNullOrUndefined(this.props.formik.values[this.props.filter.Key + suffix]) ? this.props.formik.values[this.props.filter.Key + suffix][0] : null;
        if (idx === 0 && (isNullOrUndefined(val) || val === "0001-01-01")) val = "";
        if (idx === 1 && (isNullOrUndefined(val) || val === "9999-12-31")) val = "";
        return (
            <React.Fragment>
                <div style={{ flexDirection: "row" }} className="col px-1 date-picker-overlay-reversed-direction">
                    <BbInput type="custom"
                        label={this.props.translate("Search.Filter.CreationDate." + suffix)}
                        placeholder={{ type: "column" }}
                        custom={<BbDatePicker enableReinitialize
                            afterDateChange={day => this.onDateChange(idx, day)}
                            field={this.props.filter.Key + suffix}
                            value={val}
                            rightPanel={true}
                            formDateFormat="YYYY-MM-DD"
                            yearsBack={120}
                        />}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default withLocalize(connectFormik(DateRange))